module.exports = __webpack_public_path__ + "img/upgrade-banner-application.bcf8a682.png";